import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import reactjs from '../assets/images/reactjs.jpg';
import react from '../assets/images/react.png';
import training8 from '../assets/images/training8.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';

class ReactBundle extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${training8})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"Let’s go invent tomorrow rather than worrying about what happened yesterday."</p>
                <p>
                &mdash; Steve Jobs.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${reactjs})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">React Js web development</h3>
            <img src={react} alt="React Js training in abuja" />
            <p> 
               React Makes it simple and painless to create interactive user interfaces by writing reusable codes that can be used for several components.
            </p>
            <p> 
                This training will teach you how to build a dynamic, data-driven website using the React Library.
            </p>

            <h3>courses</h3>
            <p>
                HTML5, CSS3, Bootstrap For React, React.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default ReactBundle;